var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shows ? _c('div', {
    staticClass: "node-area-edit"
  }, [_c('v-btn', {
    attrs: {
      "x-small": "",
      "icon": "",
      "color": "primary"
    },
    on: {
      "!click": function ($event) {
        $event.stopPropagation();
        return _vm.setIsEdit.apply(null, arguments);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-pencil-circle")])], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }